<template>
  <el-autocomplete ref="fetchSuggestions"
                   v-model="value"
                   :trigger-on-focus="configData.triggerType"
                   :fetch-suggestions="querySearchAsync"
                   @select="handleSelect"
                   :placeholder="configData.placeholder"
                   :maxlength="configData.maxlength"
                   :disabled="configData.disabled"
                   @change="handleChanges"
                   @blur.native.capture="handleBlur"
                   @click.native="handleClick"
                   :key="autocomplete_key"
                   clearable
                   @clear="clearSearch"
                   @paste.native.capture.prevent="handlePaste"
                   :highlightShow="configData.highlightShow"
                   oncut="return false"
                   style="width: 100%"
                   v-bind="configData">
  </el-autocomplete>
</template>
<script>
/**
 * @desc 拼音码组件
 *  取配置优先级  config传参 > typeUse配置 > 默认值
 * @param typeUse {String}  2022.11.01版本添加使用。可不传config 转移到autocomplete_config.js 维护常用配置
 *        typeUse  会去兼容 config  如果当需要替换 url soleValue queryStr... 等参数 config配置时 传入config配置进行覆盖即可
 *
 * @param config {} 必穿配置项   *(2022.11.01版本已取消必传可替换为 typeUse 配套实现)
 *-- @param url { String } 要请求的地址 默认为承运商
 *-- @param queryStr 请求接口的查询参数字段 默认searchCode
 *-- @param label  要显示的拼音码字段 默认carrierName
 *-- @param value  要传给后台的拼音码字段 默认carrierCode
 *-- @param PasteType  是否处理粘贴数据 默认true
 *-- @param placeholder  placeholder显示名称
 *-- @param soleValue  需要存储的唯一字段名（id,code）
 *-- @param triggerType  是否需要在输入框获取焦点时获取数据 默认true
 *-- @param disabled   原生属性
 *-- @param maxlength  原生属性 默认20
 *-- @param selectType  暂未启用
 *-- @param customQuery  自定义其他查询参数
 *-- @param highlightShow 是否高亮关键字
 *-- @param onState 是辅助录入
 *-- @param initQuery 初始查询（默认false）
 * @param {@input} 数据变更时通知，参数会默认同步到v-model绑定的值，
 * @param {@alteration} 选择下拉的回调 @alteration=xxx_function($event)
    说明
  * @param formData {**Object} 拼音码需要两个字段维护，传值用唯一值（id,code） 显示用name， 即v-model绑定name显示，需要代码处理唯一值的传递
   ****** 如果你尝试不用处理函数同时在使用时存储两个字段的值 传入formData (数据源对象) 并且在config中传入你的字段名
   ****** 当自动处理两个字段不够用时 @alteration 将会把你的选择项 {Object} 通过$event 注入到你的回调里，  ***用于带出其他值，只关注本身的两个值传入formData即可***
 */

import {
  getDictionariesAutocomplete,
  getDictionariesCancel,
} from '@/basic-common/util/dictionaries.js'
import emitter from 'element-ui/src/mixins/emitter' // 分发事件的el-form处理方法
import autocomplete_config from '@/basic-common/util/autocomplete-config.js' // 常用拼音码配置集
import { deepClone } from '@/util/util'
export default {
  name: 'AutocompleteReset',
  mixins: [emitter],
  watch: {
    value(val) {
      // if (this.readonly && this.onState) {
      this.$emit('input', val || null)
      this.$emit('handleChange', val || null)
      this.dispatch('ElFormItem', 'el.form.change', val || null)
      // }
    },
  },
  data() {
    return {
      inmputFocus: false,
      list: [],
      copy_value: null,
      debounceMethod: Function,
      first: false,
      readonly: true,
      autocomplete_key: false,
      storagePlaceholder: '',
      all_list: [],
      configData: {
        url: '',
        queryStr: 'searchCode',
        label: '',
        value: '',
        onState: false, //true为辅助录入
        placeholder: '拼音码检索',
        soleValue: '',
        maxlength: '20',
        PasteType: false,
        selectType: true,
        triggerType: true,
        customQuery: {},
        highlightShow: false,
        disabled: this.disabled,
        initQuery: this.initQuery,
      },
    }
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
    formData: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    typeUse: {
      type: String,
      default: 'defaultVal', //设置的默认配置  默认为 blade-vardict 服务下的产品配置
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    initQuery: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.initAutocompleteConfig()
    if (this.initQuery) {
      this.getAllList()
    }
  },
  methods: {
    initAutocompleteConfig() {
      const typeUseConfig = autocomplete_config[this.typeUse]
      const typeUseConfigCustomQuery = deepClone(this.config.customQuery || {})

      this.configData = {
        ...this.configData,
        ...typeUseConfig,
        ...this.config,
        customQuery: {
          ...typeUseConfig.customQuery,
          ...typeUseConfigCustomQuery,
        },
      }
    },
    clearSearch() {
      this.value = ''
      if (this.formData) {
        this.$emit('input', '')
        this.formData[this.configData.soleValue] = ''
        this.$set(this.formData, this.configData.soleValue, '')
      }
      this.$emit('alteration', '')
      this.$refs.fetchSuggestions.handleFocus()
      this.$set(
        this.configData,
        'placeholder',
        this.configData.placeholder || this.storagePlaceholder
      )
      this.autocomplete_key = !this.autocomplete_key
    },
    // 添加可选http重复取消和普通http请求
    async getList(
      queryStr,
      cb,
      getDictionariesCancels = getDictionariesCancel
    ) {
      this.list =
        typeof this.configData.url == 'string'
          ? await getDictionariesCancels(
              `${this.configData.url}?${this.configData.queryStr}=${queryStr}`,
              this.configData.customQuery
            )
          : this.configData.url
      this.list.forEach((item) => {
        item.label = item.label = item[this.configData.value]
        item.value = item[this.configData.label]
      })
      cb && cb(this.list)
      return this.list
    },
    // 先调用一次的默认数据
    async getAllList() {
      let res =
        typeof this.configData.url == 'string'
          ? await getDictionariesAutocomplete(
              `${this.configData.url}?${this.configData.queryStr}=`,
              this.configData.customQuery
            )
          : this.configData.url
      res.forEach((item) => {
        item.label = item.label = item[this.configData.value]
        item.value = item[this.configData.label]
      })
      this.all_list = res
    },
    querySearchAsync(queryStr, cb) {
      // 极限测试下http接口紊乱问题处理  -repetition取消重复请求 -首次接口先调用并预留1500毫秒响应时间 （* 8.25 ：16.06版本取消了预留时间）
      this.debounceMethod = this.debounce(async () => {
        if (!queryStr) {
          this.all_list.length
            ? cb([...this.all_list])
            : this.getList('', cb, getDictionariesAutocomplete)
        } else {
          let list = await this.getList(queryStr, cb)
          // 清空唯一值 当拼音码维护的数据字段为两个时 某次更新输入值时只要不是从数据源中勾选的值会造成携带更新前（唯一值）的情况
          // 已考虑只维护一个值的情况不做清空
          if (this.formData && this.configData.value != this.configData.label) {
            let item_index = list.findIndex((item) => item.value == this.value)
            if (
              item_index == -1 ||
              this.formData[this.configData.soleValue] != list[item_index].label
            ) {
              if (this.configData.onState)
                this.formData[this.configData.soleValue] = null
            }
          }
        }
      }, 200)
      this.debounceMethod()
    },
    handleSelect(item) {
      this.$emit('input', item.value || undefined)
      //利用 浅拷贝 污染赋值
      if (this.formData) {
        this.formData[this.configData.soleValue] = item.label
        this.$emit('alteration', item)
      } else {
        this.$emit('alteration', item)
      }
    },
    // 粘贴 处理
    async handlePaste(eve) {
      this.value = eve.clipboardData.getData('Text')
      if (!this.value) return
      if (!this.configData.PasteType)
        return this.$refs.fetchSuggestions.getData(this.value)
      this.list =
        typeof this.configData.url == 'string'
          ? await getDictionariesAutocomplete(
              `${this.configData.url}?${this.configData.queryStr}=${this.value}`,
              this.configData.customQuery
            )
          : this.configData.url
      //防止处理时使用转义后的字段
      this.list.forEach((item) => {
        item.label = item.label = item[this.configData.value]
        item.value = item[this.configData.label]
      })
      // 考虑拼接手机号的双字段显示，此时 value为正确名称
      if (
        this.list.length == 1 &&
        (this.list[0][this.configData.value] == this.value ||
          this.list[0][this.configData.label] == this.value)
      ) {
        if (this.formData) {
          this.formData[this.configData.soleValue] =
            this.list[0][this.configData.value]
          this.$emit('alteration', this.list[0])
          this.copy_value = this.value
        } else {
          this.$emit('alteration', this.list[0])
        }
      } else {
        this.formData[this.configData.soleValue] = ''
      }
      // 扩展rich_element刷新数据方法
      this.$refs.fetchSuggestions.getData(this.value)
    },
    debounce(fn, wait) {
      let timer = null
      return function () {
        let _that = this
        if (timer) {
          clearTimeout(timer)
          timer = null
        }
        timer = setTimeout(function () {
          fn.apply(_that, arguments)
        }, wait)
      }
    },
    handleBlur() {
      this.inmputFocus = false
      if (!this.readonly && !this.configData.onState) {
        this.readonly = !this.readonly
        if (
          this.configData.PasteType &&
          this.formData[this.configData.soleValue]
        ) {
          this.$set(this, 'value', this.copy_value)
        } else {
          this.$set(this, 'value', this.configData.placeholder)
        }
        this.$set(this.configData, 'placeholder', this.storagePlaceholder)
      }
    },
    handleClick() {
      if (!this.initQuery) {
        this.getAllList()
        this.initQuery = !this.initQuery
      }
      if (this.configData.disabled) return
      if (this.readonly && !this.configData.onState) {
        if (!this.inmputFocus) {
          this.storagePlaceholder = this.configData.placeholder
          this.$set(this.configData, 'placeholder', this.value)
          this.copy_value = this.value
          this.value = ''
          this.readonly = !this.readonly
        }
      }
      this.inmputFocus = true
    },
    handleChanges() {
      this.$emit('handleChanges', this.value)
    },
  },
}
</script>
<style scoped lang="scss"></style>
